<div
  id="sidebar-right"
  class="closed"
  [ngClass]="{ closed: !this.open }"
>
  <div class="top-bar">
    <dx-button
      id="close-icon"
      [type]="'text'"
      [stylingMode]="'text'"
      (click)="close()"
      icon="fas fa-times"
      class="float-start"
    ></dx-button>
    <div class="logo-bg">
      <app-profile-image
        [class.animate]="this.open"
        [profileImg]="profile?.profilePicture?.key"
      ></app-profile-image>
    </div>
    @if (this.isLoggedIn && !authService.registrateUser) {
      <div class="profile-container">
        <div class="profile">
          {{ displayUser() }}
        </div>
      </div>
    }
    <div class="language-selector-container">
      @if (languages.length > 1) {
        <dx-select-box
          id="custom-templates"
          stylingMode="underlined"
          [items]="languages"
          [(value)]="selectedLanguage"
          (onValueChanged)="onLanguageSelect($event)"
          [(opened)]="langMenuOpened"
        ></dx-select-box>
      }
    </div>
  </div>

  @if (!this.isLoggedIn && !authService.registrateUser && !authService.resetPasswordUser) {
    <app-login></app-login>
  }
  @if (authService.registrateUser) {
    <app-registration></app-registration>
  }
  @if (authService.resetPasswordUser) {
    <app-reset-password></app-reset-password>
  }

  @if (this.isLoggedIn && !authService.registrateUser) {
    <div class="right-menu">
      <div class="sidebar-right-content">
        <ul class="list-view">
          <li class="list-item">
            <a
              class="text"
              (click)="close()"
              [routerLink]="['/account', 'profile']"
              >{{ 'general.navigation.profile' | translate }}</a
            >
          </li>
          <li class="list-item">
            <a
              class="text"
              (click)="close()"
              [routerLink]="['/feed', 'subscriptions']"
              >{{ 'general.navigation.abo' | translate }}</a
            >
          </li>
          <li class="list-item">
            <a
              class="text"
              (click)="close()"
              [routerLink]="['/feed']"
              [queryParams]="{ feedtype: feedTypes.BOOKMARKED }"
              routerLinkActive="active"
              >{{ 'general.navigation.favourit' | translate }}</a
            >
          </li>
          <li class="list-item">
            @if (this.permissionService.checkScopes(['mgmt.feedpost.create', 'feedpost.create'])) {
              <a
                class="text"
                (click)="close()"
                [routerLink]="['/feed']"
                [queryParams]="{ feedtype: feedTypes.CREATED }"
                routerLinkActive="active"
                >{{ 'general.navigation.own' | translate }}</a
              >
            }
          </li>
          <li class="list-item">
            @if (this.permissionService.checkScopes(['mgmt.cmssite.create'])) {
              <a
                class="text"
                (click)="close()"
                [routerLink]="['/site/list']"
                >{{ 'general.navigation.site' | translate }}</a
              >
            }
          </li>
          @if (isNative() && !authService.pushStatus) {
            <li class="list-item">
              <a
                class="text"
                (click)="changePushSetting(true)"
                >{{ 'general.navigation.push.activate' | translate }}</a
              >
            </li>
          }
          @if (isNative() && authService.pushStatus) {
            <li class="list-item">
              <a
                class="text"
                (click)="changePushSetting(false)"
                >{{ 'general.navigation.push.deactivate' | translate }}</a
              >
            </li>
          }
        </ul>
        @if (canViewNonApprovedEntries || canViewContentReports) {
          <ul class="list-view separator">
            @if (canViewNonApprovedEntries) {
              <li class="list-item">
                <a
                  class="text"
                  (click)="close()"
                  [routerLink]="['/feed']"
                  [queryParams]="{ feedtype: feedTypes.NOT_APPROVED }"
                  routerLinkActive="active"
                >
                  {{ 'general.navigation.not_approved_posts' | translate }}
                  <span class="badge">{{ notApprovedFeedPostCount }}</span>
                </a>
              </li>
            }
            @if (canViewContentReports) {
              <li class="list-item">
                <a
                  class="text"
                  (click)="close()"
                  [routerLink]="['/mgmt', 'report-content']"
                  routerLinkActive="active"
                >
                  {{ 'general.navigation.content_reports' | translate }}
                  <span class="badge">{{ contentReportsCount }}</span>
                </a>
              </li>
            }
          </ul>
        }
        @if (
          this.permissionService.checkScopes([
            'mgmt.tag.read',
            'mgmt.account.read',
            'mgmt.user.read',
            'mgmt.event.read',
            'mgmt.role.read',
            'mgmt.scope.read',
            'mgmt.context.read',
            'mgmt.attribute.read',
            'damagereport.create.hide_at_the_moment',
            'mgmt.analytics.read',
          ])
        ) {
          <ul class="list-view separator">
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.tag.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/tag']"
                  (click)="close()"
                  ><i class="fa fa-tags"></i> {{ 'tag.mgmt.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.account.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/account']"
                  (click)="close()"
                  ><i class="fa fa-cube"></i> {{ 'account.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.user.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/user']"
                  (click)="close()"
                  ><i class="fa fa-users"></i> {{ 'user.mgmt.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.client.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/client']"
                  (click)="close()"
                  ><i class="fa fa-id-badge"></i> {{ 'client.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.role.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/role']"
                  (click)="close()"
                  ><i class="fa fa-user-lock"></i> {{ 'role.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.scope.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/scope']"
                  (click)="close()"
                  ><i class="fas fa-box"></i> {{ 'scope.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.context.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/context']"
                  (click)="close()"
                  ><i class="fas fa-border-style"></i> {{ 'context.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.lang.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/language']"
                  (click)="close()"
                  ><i class="fas fa-language"></i> {{ 'language.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.translation.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/translation']"
                  (click)="close()"
                  ><i class="fas fa-language"></i> {{ 'translation.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.attribute.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/attribute']"
                  (click)="close()"
                  ><i class="fab fa-buffer"></i> {{ 'attribute.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['mgmt.config.read'])) {
                <a
                  class="text"
                  [routerLink]="['/mgmt/backend-setting']"
                  (click)="close()"
                  ><i class="fas fa-cogs"></i> {{ 'backendSetting.navLabel' | translate }}</a
                >
              }
            </li>
            <li class="list-item">
              @if (this.permissionService.checkScopes(['damagereport.create.hide_at_the_moment'])) {
                <a
                  class="text cursor-pointer"
                  (click)="damageReport()"
                  ><i class="fas fa-paper-plane"></i> {{ 'report.href' | translate }}</a
                >
              }
            </li>
            @if (!!this.analyticsUrl) {
              <li class="list-item">
                @if (this.permissionService.checkScopes(['mgmt.feedpost.read', 'mgmt.event.read'])) {
                  <a
                    class="text"
                    [href]="this.analyticsUrl"
                    target="_blank"
                    ><i class="fa fa-chart-line"></i> {{ 'general.navigation.googleAnalytics' | translate }}
                    <i class="fa fa-external-link-alt upper-icon"></i
                  ></a>
                }
              </li>
            }
          </ul>
        }
        <ul class="list-view separator">
          <li class="list-item">
            <a
              class="text cursor-pointer"
              (click)="logout()"
              ><i class="fa fa-sign-out-alt"></i> {{ 'general.buttons.logout' | translate }}</a
            >
          </li>
          <li class="list-item">
            @if (this.permissionService.checkScopes(['feedback.create'])) {
              <a
                class="text cursor-pointer"
                (click)="feedback()"
                ><i class="fa fa-bullhorn"></i> {{ 'general.navigation.feedback' | translate }}</a
              >
            }
          </li>
        </ul>
      </div>
    </div>
  }
</div>

<app-popup
  [title]="'general.navigation.feedback' | translate"
  [visible]="(this.layoutService.isFeedbackShown | async) ?? false"
  (visibleChange)="this.layoutService.isFeedbackShown.next($event)"
>
  <app-feedback (closeFeedback)="this.layoutService.isFeedbackShown.next(false)"></app-feedback>
</app-popup>

<app-popup
  [title]="'report.href' | translate"
  [visible]="(this.layoutService.isDamageReportShown | async) ?? false"
  (visibleChange)="this.layoutService.isDamageReportShown.next($event)"
>
  <app-damage-report (closeDamageReport)="this.layoutService.isDamageReportShown.next(false)"></app-damage-report>
</app-popup>
